import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Client } from '../models/client';
import { ClientContact } from '../models/client-contact';

@Injectable({
  providedIn: 'root'
})
export class ClientContactService {


baseUrl = environment.apiEndpoint + '/client/clientcontact';

constructor(private http: HttpClient) {}

GetClientContacts(clientId: string): Observable<ClientContact[]> {
  return this.http.get<ClientContact[]>(this.baseUrl + '/' + clientId);
}

// Every client contact in the instance (each carries id, name, email, clientId + clientName).
GetAllClientContacts(): Observable<{ id: string; name: string; email: string | null; clientId: string; clientName: string }[]> {
  return this.http.get<{ id: string; name: string; email: string | null; clientId: string; clientName: string }[]>(
    environment.apiEndpoint + '/client/clientcontacts');
}

AddClientContact(model: any): Observable<ClientContact> {
  return this.http.post<ClientContact>(this.baseUrl + '', model);
}

EditClientContact(model: any): Observable<ClientContact> {
  return this.http.put<ClientContact>(this.baseUrl + '/' + model.id, model);
}

DeleteClientContact(model: any) {
  return this.http.delete(this.baseUrl + '/' + model.id);
}
}
